"use client";
import { CircleCheck } from "lucide-react";
import Image from "next/image";
import krooloImage from "@/assets/images/allinone/one.svg";
import AllInOneVideoWrapper from "./AllInOneVideoWrapper";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "@/components/common/CommonTitle";

const pros = [
  "Enterprise AI",
  "40+ Custom AI Agents",
  "AI Workflow Builder",
  "Enterprise search",
  "AI Projects",
  "AI Task Planner",
  "AI Dashboard",
  "AI Goals / OKRs for Teams",
  "AI Docs",
  "AI Forms",
];

const AllInOneFeatures = () => {
  return (
    <>
      <div className="bg-[#F6F8FE] py-12 xl:py-20">
        <div className="container mx-auto flex flex-col items-center justify-center px-4 pb-4">
          <div className="mx-auto mb-16 max-w-xl">
            <CommonTitle
              color="#202020"
              fontSizeClass="text-[24px] lg:text-[32px] mb-2 lg:mb-4 text-center"
              fontWeightClass="font-semibold"
              as="h2"
            >
              Enterprises using Kroolo yield upto{" "}
              <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                70% productivity improvement
              </span>
            </CommonTitle>
            <CommonSubtitle
              color="#202020"
              fontSizeWeight="max-w-[900px] mx-auto text-center"
            >
              180+ Features | Custom AI Agents | 50+ Integrations
            </CommonSubtitle>
          </div>
          <div className="flex flex-col gap-4 md:gap-8 lg:flex-row">
            <div className="flex max-w-full flex-col md:max-w-[480] xl:max-w-[520px]">
              <div className="flex h-full w-full items-center justify-center rounded-t-2xl bg-[#DCE2ED] p-6 md:h-[152px] xl:h-[160px]">
                <div className="xl:max-w-[240px]">
                  <CommonTitle
                    color="#202020"
                    fontSizeClass="text-[20px] lg:text-[22px] text-center"
                    fontWeightClass="font-semibold"
                    as="h3"
                  >
                    Work is broken with these tools
                  </CommonTitle>
                </div>
              </div>
              <div className="h-full rounded-b-2xl bg-[#f3f3f3] md:h-[600px]">
                <AllInOneVideoWrapper />
              </div>
            </div>
            <div className="flex max-w-full flex-col md:max-w-[480] xl:max-w-[520px]">
              <div className="flex h-full w-full justify-center rounded-t-2xl md:h-[152px] xl:h-[160px]">
                <Image
                  src={krooloImage}
                  draggable={false}
                  alt="Kroolo as your one app - All-in-one platform"
                  className="sm:h-full sm:w-full sm:object-contain"
                />
              </div>
              <div className="flex h-full flex-col gap-4 rounded-b-2xl bg-white p-6 md:h-[600px] xl:gap-6 xl:p-10">
                <CommonTitle
                  color="#202020"
                  fontSizeClass="text-[20px] lg:text-[22px]"
                  fontWeightClass="font-semibold"
                  as="h3"
                >
                  Kroolo as your One App
                </CommonTitle>
                <ul className="space-y-4 text-left xl:space-y-6">
                  {pros.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-2 text-[16px]"
                    >
                      <CircleCheck className="mt-0.5 h-5 w-5 text-green-600" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllInOneFeatures;
